import 'bootstrap/js/dist/collapse.js';
import $ from 'jquery';
import Ui, {initRevealAnimation} from '../../js/Ui.mjs';

export default class Collapse {
  constructor() {
    _initCollapseSmartScroll.call(this);
    _initTeaserCollapsibleLarge.call(this);
  }
}

/**
 * Scroll to top of Collapse button when opening, if it's not visible.
 *
 * Activated by adding "smart-scroll" attribute besides data-toggle="collapse".
 *
 * Usually used in accordion like components, where the target button can be
 * moved outside of the viewport, when a previous collapse content is closed.
 */
function _initCollapseSmartScroll() {
  const $buttons = $('[data-toggle="collapse"][smart-scroll]');

  $buttons.each((index, button) => {
    const $button = $(button);
    const $collapseTarget = $($button.data('target'));

    $collapseTarget.on('shown.bs.collapse', (event) => {
      // Prevent event bubbling within nested collapse
      event.stopPropagation();

      Ui.then((Ui) => {
        const buttonOffset = $button.offset().top;
        const documentOffset = $(document).scrollTop();
        const headerHeight = Ui.Header.getHeight();
        const targetOffset = buttonOffset - headerHeight;
        const isButtonTopOutOfViewport = targetOffset < documentOffset;

        if (isButtonTopOutOfViewport) {
          $('html,body').animate({
            scrollTop: targetOffset,
          }, 250);
        }
      });
    });
  });
}

function _initTeaserCollapsibleLarge() {
  const $teasers = $('.ef-teaser-collapsible-large');

  $teasers.each((index, teaser) => {
    const $teaser = $(teaser);
    const $button = $teaser.find('.ef-button-collapse');
    const $collapseTarget = $($button.data('target'));

    if ($collapseTarget.length !== 1) {
      // Do nothing
      return;
    }

    const $items = $teaser.find('[data-reveal-item]');

    $collapseTarget
      .on('show.bs.collapse', () => {
        // Hide content
        $items.addClass('invisible');
      })
      .on('shown.bs.collapse', () => {
        // Init reveal
        $items.addClass('reveal');

        // ... then
        initRevealAnimation($items);
        $items.removeAttr('data-reveal-item');

        // "Show" content (now hidden by .reveal)
        $items.removeClass('invisible');

        // Cleanup
        $collapseTarget
          .off('show.bs.collapse')
          .off('shown.bs.collapse');
      });
  });
}
